<template>
  <div v-if="canSee" class="vs-sidebar--item" :class="[
      {'vs-sidebar-item-active'            : activeLink},
      {'disabled-item pointer-events-none' : isDisabled}
    ]">

    <router-link :id="id" tabindex="-1" v-if="to" exact :class="[{'router-link-active': activeLink}]" :to="to" :target="target">
      <vs-icon style="margin-right: 15px;" :icon="`speakol-${icon}`" icon-pack="speakol"></vs-icon>
      <slot/>
    </router-link>

    <a v-else :target="target" :href="href" tabindex="-1">
      <vs-icon style="margin-right: 15px;" :icon="`speakol-${icon}`" icon-pack="speakol"></vs-icon>
      <slot/>
    </a>

  </div>
</template>

<script>
export default {
  name: 'v-nav-menu-item',
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconSmall: {
      type: Boolean,
      default: false
    },
    iconPack: {
      type: String,
      default: 'speakol'
    },
    href: {
      type: [String, null],
      default: '#'
    },
    to: {
      type: [String, Object, null],
      default: null
    },
    slug: {
      type: String,
      default: null
    },
    index: {
      type: [String, Number],
      default: null
    },
    target: {
      type: String,
      default: '_self'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    id: {}
  },
  computed: {
    canSee () {
      return true
    },
    activeLink () {
      return !!((this.to === this.$route.path || this.$route.meta.parent === this.slug) && this.to)
    }
  }
}
</script>
